export const esUYLocale = {
  components: {
    modal: {
      biometry_request: {
        action: 'IDENTIFICARSE CON DNI',
      },
    },
  },
  pages: {
    home: {
      actions: {
        cpf_checkin: 'Check-in con DNI',
      },
    },
  },
};
